"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOtherIncomeData = exports.otherIncomeFormRules = exports.otherIncomeSchema = void 0;
const converters_1 = require("../../converters");
const income_1 = require("./income");
exports.otherIncomeSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Income Type must be 200 characters or less',
        },
        contact_name: {
            maxLength: 'Contact Name must be 50 character or less',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.otherIncomeFormRules = (0, converters_1.toReactHookForm)(exports.otherIncomeSchema, income_1.incomeFieldMapping);
exports.validateOtherIncomeData = (0, converters_1.createValidator)(exports.otherIncomeSchema);
